// extracted by mini-css-extract-plugin
export default {"root":"styles_root__q7Suk","label":"styles_label__5VoSD","error":"styles_error__htsqm","icon":"styles_icon__1+Rzi"};